import { useRef, useEffect } from 'react';

function useOnceWhen(condition, callback) {
  const called = useRef(false);

  useEffect(() => {
    if (condition && !called.current) {
      callback();
      called.current = true;
    }
  }, [condition, callback]);
}

export default useOnceWhen;
